import classNames from 'classnames'
import { type FC, type ReactNode, useState } from 'react'
import { usePausableAutoHide } from '../../common/usePausableAutoHide'
import styles from './SaveBarFrame.module.scss'
import { type SaveBarNotice } from './saveBarNotice'
import { SaveBarNoticeStrip } from './SaveBarNoticeStrip'

export interface SaveBarFrameProps {
  notice: SaveBarNotice | null
  onDismissNotice: () => void
  onContactSupport: () => void
  className?: string
  children: ReactNode
}

const FRAME_CLASSNAMES: Record<SaveBarNotice['variant'], string> = {
  success: classNames('zocks-bg-color-success-background', styles.successFrame),
  error: classNames('zocks-bg-color-danger-background', styles.errorFrame),
}

export const SaveBarFrame: FC<SaveBarFrameProps> = ({ notice, onDismissNotice, onContactSupport, className, children }) => {
  const [hoveredNotice, setHoveredNotice] = useState<SaveBarNotice | null>(null)
  const [focusedNotice, setFocusedNotice] = useState<SaveBarNotice | null>(null)
  const isPaused = notice !== null && (hoveredNotice === notice || focusedNotice === notice)
  usePausableAutoHide({ durationMs: notice?.autoHideMs, isPaused, onExpire: onDismissNotice, resetKey: notice })

  return (
    <div className={classNames(className, notice ? FRAME_CLASSNAMES[notice.variant] : null)}>
      {notice ? (
        <div
          onMouseEnter={() => setHoveredNotice(notice)}
          onMouseLeave={() => setHoveredNotice(null)}
          onFocus={() => setFocusedNotice(notice)}
          onBlur={(event) => {
            if (!event.currentTarget.contains(event.relatedTarget)) {
              setFocusedNotice(null)
            }
          }}
        >
          <SaveBarNoticeStrip notice={notice} onDismiss={onDismissNotice} onContactSupport={onContactSupport} />
        </div>
      ) : null}
      {children}
    </div>
  )
}
